import React from 'react';
import { NavLink } from 'react-router-dom';

class CoreFeatures extends React.Component {
	render() {
		return (
			<div className="fullwidth dark">
				<div className="row">
					<div className="four columns">
						<h2>Hardware Encryption</h2>
						<hr className="grey" />
						<p>AMD Secure Encrypted Virtualization (SEV) encrypts each virtual machine's memory with unique keys known only to your workload. Processor-level encryption ensures your data remains protected even from the host system, hypervisor, or someone with physical server access. This creates a zero-trust architecture where cryptographic proof of confidentiality is mathematically guaranteed, not just promised.</p>
					</div>
					<div className="four columns">
						<h2>Swiss Data Protection</h2>
						<hr className="grey" />
						<p>All confidential computing servers are hosted in ISO 27001 certified facilities in Zurich, Switzerland. Combined with <NavLink to="/en/data-protection-switzerland">Switzerland's strict data protection laws</NavLink> and political neutrality, hardware-enforced encryption provides exceptional data sovereignty. Perfect for GDPR, PCI-DSS, and other regulatory compliance requirements where both legal and technical safeguards are essential.</p>
					</div>
					<div className="four columns">
						<h2>Dedicated Performance</h2>
						<hr className="grey" />
						<p>Enterprise-grade AMD EPYC processors deliver dedicated-class performance with instant provisioning and on-demand scaling. High-performance NVMe storage provides approximately 90,000 read IOPS and 38,000 write IOPS with sub-millisecond latency. Dedicated 10 Gigabit Ethernet connectivity with no oversubscription ensures consistent network performance for production workloads.</p>
					</div>
				</div>
			</div>
		)
	}
}

export default CoreFeatures;
